<div class="hero-section" [class.flat-bottom]="flatBottom()">
  <div class="hero-content">
    <h1>{{ title() }}</h1>
    @if (subtitle()) {
      <p class="hero-subtitle">{{ subtitle() }}</p>
    }
    @if (metaItems().length > 0) {
      <div class="hero-meta">
        @for (item of metaItems(); track item.text) {
          <span class="meta-item">
            <htx-icon [icon]="item.icon"></htx-icon>
            {{ item.text }}
          </span>
        }
      </div>
    }
    <ng-content></ng-content>
  </div>
</div>
